import React, { ReactNode } from 'react';
import { View } from 'react-native';
import { DeviceInfo, AppInfo, QLoginManager } from 'qunar-react-native';
import Header from './Header';
import '../../config/fontSet/font'
import isLowAdr from '../../constant/isLowAdr';
import { OrderMainView, FILTER_DATA_MAP, getBusinessTypeFromUrl, getQueryParam } from '@qnpm/cmn-component-order';
import generateRNUrl from '../../utils/generateRNUrl';
import { navigate } from '../../utils/navigate';
import { Colors } from '@qnpm/q-theme';
import {qav} from "../../utils/qav";

const { isWeb } = DeviceInfo;

const { scenes: { baseColor } } = Colors;

// global.$orderMainHasLoaded = false;

class OrderMain extends QView<any> {
    public static routerPlugin = {
        // isShow: true,
        // backgroundColor:'white',
        // color: 'black',
        // buttonWidth: 1,
        // statusBarBackgroundColor: isLowAdr ? 'black' : baseColor.background2,
        // height: 0,
        // activeOpacity: 0.6,
        // title: '',
        // // leftButtonText: '',
        // leftButtonPressEvent() {},
        // // rightButtonText: '',
        // rightButtonPressEvent() {}
    };

    public bindEvents = {
        actived: () => {
            if (this.orderMainViewRef && this.orderMainViewRef.handleActived) {
                this.orderMainViewRef.handleActived();
            }
            if(this.orderMainViewRef && this.orderMainViewRef.requestUpdateOrderItem){
                this.orderMainViewRef.requestUpdateOrderItem()
            }
        },
        deactived: () => {
            if (this.orderMainViewRef && this.orderMainViewRef.handleDeactived) {
                this.orderMainViewRef.handleDeactived();
            }
        }
    };


    public headerViewRef: any;
    public orderMainViewRef: any;
    public isOpenFilterState = false;
    public businessType = '';
    public state = {
        filterTitle: ''
    };
    public constructor(props: any) {
        super(props);
        this.orderMainViewRef = null;
        const { param = {} } = this.props;
        let {
            // source: sourceFrom = 'list',
            // statusFilter = 'all',
            businessType: businessId = 'all'
        } = param;
        if(isWeb){
            businessId = getBusinessTypeFromUrl()
        }
        this.businessType = businessId;
        const obj = FILTER_DATA_MAP[businessId];
        let title = '';
        if (obj) {
            title = obj.title;
        }
        if (title.length === 0 || title === '全部') {
            title = '全部订单';
        }
        this.state = {
            filterTitle: title
        };

        switch (title) {
            case '机票':
                qav({
                    page: 'order_rn_main',
                    module: 'orderList',
                    operType: 'enter',
                    bizType: "pp",
                    title: "机票订单tab",
                    operTime: new Date().getTime().toString(),
                    key: "pp/order_rn_main/orderList/enter/flight",
                    id: 'flight',
                    appcode: 'cmn_order_rn'
                });
                break;
            case '酒店住宿':
                qav({
                    page: 'order_rn_main',
                    module: 'orderList',
                    operType: 'enter',
                    bizType: "pp",
                    title: "酒店订单tab",
                    operTime: new Date().getTime().toString(),
                    key: "pp/order_rn_main/orderList/enter/hotel",
                    id: 'hotel',
                    appcode: 'cmn_order_rn'
                });
                break;
            case '火车票':
                qav({
                    page: 'order_rn_main',
                    module: 'orderList',
                    operType: 'enter',
                    bizType: "pp",
                    title: "火车票订单tab",
                    operTime: new Date().getTime().toString(),
                    key: "pp/order_rn_main/orderList/enter/train",
                    id: 'train',
                    appcode: 'cmn_order_rn'
                });
                break;
            default:
                qav({
                    page: 'order_rn_main',
                    module: 'orderList',
                    operType: 'enter',
                    bizType: "pp",
                    title: "业务线订单tab",
                    operTime: new Date().getTime().toString(),
                    key: "pp/order_rn_main/orderList/enter/tab",
                    id: 'tab',
                    appcode: 'cmn_order_rn',
                    ext: {
                        source: title
                    }
                });
                break;
        }
    }

    phoneSearchClick = () => {
        if (AppInfo && AppInfo.isTouristMode) {
            AppInfo.isTouristMode((res: any) => {
                if (res.isTouristMode) {
                    //QLoginManager.login();
                    QLoginManager.login((userData) => {
                        console.log(userData);                       
                    }, (err) => {
                        //登录失败
                        console.log(err);
                    });
                } else {
                    this.phoneSearchJump();
                }
            });
        } else {
            this.phoneSearchJump();
        }
    }

    phoneSearchJump = () => {
        const { param = {} } = this.props;
        let { source: sourceFrom = 'list' } = param;
        const initProps = {
            param: {
                businessType: this.businessType,
                source: sourceFrom
            }
        };
        const schema = generateRNUrl('InputTelephoneNum', undefined, initProps);
        const params = DeviceInfo.isWeb ? { isSchema: false, schema: DeviceInfo.scheme, url: `https://touch.qunar.com/mordercenter/v2/index.html?hybridid=mob_ordercenter&new_r=${Math.random()}#searchByPhone?businessType=flight%2Ctrain%2Chotel%2Chotel_sight%2Ctese%2Chuiyi%2Cticket%2Clocal%2Cqmall%2Cbus%2Cshopping&source=touch` } : { isSchema: true, schema }
        // const params = { isSchema: true, schema}
        if (isWeb) {
            window.location.href = params.url
        } else {
            navigate(params);
        }
    }

    public render() {
        const { param = {} } = this.props;
        // web端url传值过滤
        param.filterBusiness === 'false' && (param.filterBusiness = false);
        param.filterBusiness === 'true' && (param.filterBusiness = true);
        param.notShowHeader === 'true' && (param.notShowHeader = true);
        param.notShowHeader === 'false' && (param.notShowHeader = false);
        param.hideBack === 'true' && (param.hideBack = true);
        param.hideBack === 'false' && (param.hideBack = false);
        param.hideRight === 'true' && (param.hideRight = true);
        param.hideRight === 'false' && (param.hideRight = false);
        
        let { filterBusiness: enableFilter = true, notShowHeader = false } = param;
        
        return (
            <View style={{ flex: 1 , backgroundColor: baseColor.background2}}>
                {/* 导航栏 */}
                {
                    !notShowHeader
                    &&
                <Header
                    hideBack={param.hideBack}
                    hideRight={param.hideRight}
                    filterTitle={this.state.filterTitle}
                    ref={(ref: ReactNode) => {
                        this.headerViewRef = ref;
                    }}
                    enableFilter={enableFilter}
                    filterTitleOnPress={() => {
                        const curTitle = this.orderMainViewRef
                            ? this.orderMainViewRef.getCurrentTitle()
                            : '';
                        qav({
                            page: 'order_rn_main',
                            module: 'filterTitle',
                            path: [
                                {
                                    title: curTitle,
                                    position: 0
                                }
                            ],
                            operType: 'click'
                        });
                        if (this.isOpenFilterState) {
                            this.headerViewRef && this.headerViewRef.downArrowAnimation();
                            this.orderMainViewRef && this.orderMainViewRef.hideFilterBar();
                        } else {
                            this.headerViewRef && this.headerViewRef.upArrowAnimation();
                            this.orderMainViewRef && this.orderMainViewRef.showFilterBar();
                        }
                        this.isOpenFilterState = !this.isOpenFilterState;
                    }}
                    rightBtnOnPress={() => {                        
                        qav({
                            page: 'order_rn_main',
                            module: 'searchOrderByPhoneBtn',
                            path: [
                                {
                                    title: '手机查单',
                                    position: '0'
                                }
                            ],
                            operType: 'click'
                        });
                        this.phoneSearchClick();
                    }}
                />
                }                

                {/* 主视图 */}
                <OrderMainView
                    {...param}
                    filterBarBgColor={baseColor.background2}
                    filterBarBgCorner={10}
                    filterBarItemSelectedBgColor={baseColor.brand}
                    filterBarItemSelectedTitleColor={baseColor.white}
                    filterBarItemUnSelctedBgColor={baseColor.white}
                    filterBarItemUnSelctedTitleColor={baseColor.text1}

                    tabBgColor={baseColor.background2}
                    tabsPaddingHorizontal={12}
                    tabItemSelectedBgColor={baseColor.brandBorder}
                    tabItemSelectedTitleColor={baseColor.brandText}
                    tabItemUnSelctedBgColor={baseColor.white}
                    tabItemUnSelctedTitleColor={baseColor.text2}
                    ref={(ref: ReactNode) => {
                        this.orderMainViewRef = ref;
                    }}
                    selecteFilterItemCallBack={(
                        filterInfo: { [propName: string]: string },
                        index: number
                    ) => {
                        this.isOpenFilterState = false;
                        setTimeout(()=>this.headerViewRef && this.headerViewRef.downArrowAnimation(),500)
                        if (!filterInfo.native) {
                            if (filterInfo.title === '全部') {
                                filterInfo.title = '全部订单';
                            }
                            this.setState({
                                filterTitle: filterInfo.title || ''
                            });
                            this.businessType = filterInfo.id || '';
                        }
                        // alert(JSON.stringify(filterInfo) + '___' + index)
                    }}
                    clickFilterBlankAreaCallBack={() => {
                        this.isOpenFilterState = false;
                        this.headerViewRef && this.headerViewRef.downArrowAnimation();
                    }}
                >
                    {' '}
                </OrderMainView>
            </View>
        );
    }
}

export default OrderMain;
